<script>
    import { Route, Router } from 'yrv'
    import Content from '../_common/content.svelte'
    import StockDashboard from './stock-dashboard.svelte'
    import StockHome from '../stock/stock-home.svelte'
    import StockConsumables from './stock-consumables.svelte'
    import StockIn from '../stock/stock-in.svelte'
    import StockOut from '../stock/stock-out.svelte'
    import Ztab from '../_common/z/ztab.svelte'

    let tabs = []
    tabs.push({ title: 'Início', url: '/stock-v2/home' })
    tabs.push({ title: 'Estoque', url: '/stock-v2/stock' })
    tabs.push({ title: 'Insumos', url: '/stock-v2/consumables' })
    tabs.push({ title: 'Entradas', url: '/stock-v2/in' })
    tabs.push({ title: 'Saídas', url: '/stock-v2/out' })
</script>

<Content>
    <div class="root-content">
        <Ztab class="h-space" {tabs}></Ztab>
        <div class="body">
            <Router>
                <Route path="/home">
                    <StockDashboard />
                </Route>
                <Route path="/stock">
                    <StockHome />
                </Route>
                <Route path="/consumables">
                    <StockConsumables />
                </Route>
                <Route path="/in">
                    <StockIn />
                </Route>
                <Route path="/out">
                    <StockOut />
                </Route>
            </Router>
        </div>
    </div>
</Content>
